<template>
  <v-container>
    <v-row>
      <v-col cols="4" class="pa-6">
        <eta-salle-list-store v-on="$listeners"></eta-salle-list-store>
      </v-col>
      <v-divider vertical></v-divider>
      <v-col cols="8">
        <eta-salle-info-store v-if="id" :id="id"></eta-salle-info-store>
        <v-container v-else>
            <empty-state

          :value="emptyStateSalle.value"
          :title="emptyStateSalle.title"
        ></empty-state></v-container>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import emptyStateSvg from '../../assets/undraw_empty.svg'
import EtaSalleListStore from '../../components/salles/EtaSalleListStore.vue'
import EtaSalleInfoStore from '../../components/salles/EtaSalleInfoStore.vue'

export default {
  components: { EtaSalleListStore, EtaSalleInfoStore },
  name: 'salleListView',
  data: () => ({
    emptyStateSalle: {
      title: 'Sélectionner une salle',
      value: emptyStateSvg
    }
  }),
  props: {
    id: {
      type: String
    }
  }
}
</script>

<style>
</style>
